<template>
  <div id="app">
    <!-- Piano keys section -->
    <div class="piano">
      <div v-for="key in keys" :class="['piano-key', key.type, { 'active': activeKeys.includes(key.note) }]"
        :key="key.note" :style="{ 'background-color': activeKeys.includes(key.note) ? activeColor : key.color }"
        @click="playKey(key.note)">
        <!-- Label for the key -->
        <span>{{ key.note }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as Tone from 'tone';

export default {
  data() {
    return {
      keys: [
        { note: 'C4', type: 'white-key', color: 'rgba(128, 128, 128, 0.3)' }, // light gray for white keys
        { note: 'Db4', type: 'black-key', color: 'rgba(0, 0, 0, 0.7)' }, // dark gray (almost black) for black keys
        { note: 'D4', type: 'white-key', color: 'rgba(128, 128, 128, 0.3)' },
        { note: 'Eb4', type: 'black-key', color: 'rgba(0, 0, 0, 0.7)' },
        { note: 'E4', type: 'white-key', color: 'rgba(128, 128, 128, 0.3)' },
        { note: 'F4', type: 'white-key', color: 'rgba(128, 128, 128, 0.3)' },
        { note: 'Gb4', type: 'black-key', color: 'rgba(0, 0, 0, 0.7)' },
        { note: 'G4', type: 'white-key', color: 'rgba(128, 128, 128, 0.3)' },
        { note: 'Ab4', type: 'black-key', color: 'rgba(0, 0, 0, 0.7)' },
        { note: 'A4', type: 'white-key', color: 'rgba(128, 128, 128, 0.3)' },
        { note: 'Bb4', type: 'black-key', color: 'rgba(0, 0, 0, 0.7)' },
        { note: 'B4', type: 'white-key', color: 'rgba(128, 128, 128, 0.3)' },
        { note: 'C5', type: 'white-key', color: 'rgba(128, 128, 128, 0.3)' },
        { note: 'Db5', type: 'black-key', color: 'rgba(0, 0, 0, 0.7)' },
        { note: 'D5', type: 'white-key', color: 'rgba(128, 128, 128, 0.3)' },
        { note: 'Eb5', type: 'black-key', color: 'rgba(0, 0, 0, 0.7)' },
        { note: 'E5', type: 'white-key', color: 'rgba(128, 128, 128, 0.3)' },
        { note: 'F5', type: 'white-key', color: 'rgba(128, 128, 128, 0.3)' },
        { note: 'Gb5', type: 'black-key', color: 'rgba(0, 0, 0, 0.7)' },
        { note: 'G5', type: 'white-key', color: 'rgba(128, 128, 128, 0.3)' },
        { note: 'Ab5', type: 'black-key', color: 'rgba(0, 0, 0, 0.7)' },
        { note: 'A5', type: 'white-key', color: 'rgba(128, 128, 128, 0.3)' },
        { note: 'Bb5', type: 'black-key', color: 'rgba(0, 0, 0, 0.7)' },
        { note: 'B5', type: 'white-key', color: 'rgba(128, 128, 128, 0.3)' },
      ],
      chords: [
        { id: '1', name: 'C Major', notes: ['C4', 'E4', 'G4'] },
        { id: '2', name: 'D Minor', notes: ['D4', 'F4', 'A4'] },
        { id: '3', name: 'E Minor', notes: ['E4', 'G4', 'B4'] },
        { id: '4', name: 'F Major', notes: ['F4', 'A4', 'C5'] },
        { id: '5', name: 'G Major', notes: ['G4', 'B4', 'D4'] },
        { id: '6', name: 'A Minor', notes: ['A4', 'C5', 'E4'] },
        { id: '7', name: 'B Diminished', notes: ['B4', 'D4', 'F4'] },
        { id: '27', name: 'D Minor 7', notes: ['D4', 'F4', 'A4', 'C5'] },
        { id: '47', name: 'F Major 7', notes: ['F4', 'A4', 'C5', 'E4'] },
        { id: '67', name: 'A Minor 7', notes: ['A4', 'C5', 'E4', 'G4'] },
        { id: '16', name: 'C Major 6', notes: ['C4', 'E4', 'G4', 'A4'] },
        { id: '57', name: 'Gm7', notes: ['G4', 'Bb4', 'D4', 'F4'] },
        { id: '37', name: 'Em7', notes: ['E4', 'G4', 'B4', 'D4'] },
        { id: '17', name: 'Am7', notes: ['C4', 'E4', 'G4', 'B4'] },
        { id: 'b57', name: 'Gdom7', notes: ['G4', 'B4', 'D4', 'F4'] },
        { id: '564', name: 'V64', notes: ['D4', 'G4', 'B4'] },
        { id: '164', name: 'I64', notes: ['G4', 'C5', 'E4'] },
        { id: '26', name: 'ii6', notes: ['F4', 'A4', 'D5'] },
        { id: '56/5', name: 'V6/V', notes: ['Gb4', 'A4', 'D5'] },
        { id: '7/5', name: 'vii°/V', notes: ['Gb4', 'A4', 'C5'] },
        { id: '46', name: 'IV6', notes: ['A4', 'C5', 'F5'] },
        { id: '665', name: 'vi65', notes: ['A4', 'C5', 'E4', 'G4'] },
        { id: '664', name: 'vi64', notes: ['E4', 'A4', 'C5'] },
        { id: '542', name: 'V42', notes: ['F4', 'G4', 'B4', 'D5'] },
        { id: '56', name: 'V6', notes: ['G4', 'B4', 'D5', 'E5'] },
        { id: '365', name: 'iii65', notes: ['G4', 'B4', 'E5'] },
      ],
      activeKeys: [],
      chordSlots: [null, null, null, null, null],
      activeColor: '',
      // ... other data properties
    };
  },
  methods: {
    playKey(note) {
      const keyObj = this.keys.find(key => key.note === note);
      if (keyObj) {
        this.activeColor = keyObj.color; // Set the active color
        const synth = new Tone.Synth().toDestination();
        Tone.start().then(() => {
          synth.triggerAttackRelease(note, '8n');
        });
        this.activeKeys = [note];
        setTimeout(() => {
          this.activeKeys = [];
          this.activeColor = ''; // Reset the active color
        }, 500);
      }
    },
    playChord(notes) {
      // Start the audio context
      console.log('Playing chord:', notes);
      Tone.start().then(() => {
        const synth = new Tone.PolySynth(Tone.Synth).toDestination();
        synth.triggerAttackRelease(notes, '8n');
      });
      // Highlight the keys for the duration of the chord
      this.activeKeys = notes;
      setTimeout(() => { this.activeKeys = []; }, 500);
    },
    allowDrop(event) {
      event.preventDefault(); // This is necessary to allow the drop
    },
    drop(event, slotIndex) {
      event.preventDefault();
      const data = event.dataTransfer.getData('chord');
      const { chordID } = JSON.parse(data); // Extract chordID from parsed data
      this.addChordToSlot(slotIndex, chordID);
    },

    addChordToSlot(slotIndex, chordID) {
      const chord = this.chords.find(c => c.id === chordID);
      if (chord) {
        this.chordSlots[slotIndex] = chord; // Store the entire chord object
        console.log(`Chord added to slot ${slotIndex}:`, chord);
      } else {
        console.error('Chord not found with ID:', chordID);
      }
    },
    highlightKeysForChord(notes) {
      this.activeKeys = [];
      notes.forEach(note => {
        const key = this.keys.find(k => k.note === note);
        if (key) {
          // Temporarily highlight the key by adding its note to activeKeys
          this.activeKeys.push(note);
        }
      });

      // Remove the highlights after a delay
      setTimeout(() => this.activeKeys = [], 500);
    },

    playChordSlot(index) {
      const chord = this.chordSlots[index];
      if (chord && chord.notes) {
        // Start the audio context and play the chord
        Tone.start().then(() => {
          const synth = new Tone.PolySynth(Tone.Synth).toDestination();
          synth.triggerAttackRelease(chord.notes, '8n');
        });

        // Visually highlight the keys
        this.highlightKeysForChord(chord.notes);
      } else {
        console.error('No chord data found for this slot:', index);
      }
    },

    getChordNumeral(chordName) {
      // Define your mapping here, for example:
      const numerals = {
        'C Major': 'I',
        'D Minor': 'ii',
        'E Minor': 'iii',
        'F Major': 'IV',
        'G Major': 'V',
        'A Minor': 'vi',
        'B Diminished': 'vii°',
        // ... add other mappings as needed
      };
      return numerals[chordName] || chordName; // Fallback to chord name if no numeral is found
    },
  },
  // ... other methods and lifecycle hooks
};
</script>
  
<style scoped>
@import '@/styles.css'
</style>



  